var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c(
                "el-form",
                {
                  ref: "formSearch",
                  attrs: {
                    model: _vm.queryForm,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "timeType" } },
                            [
                              _c("template", { slot: "label" }, [
                                _c(
                                  "div",
                                  { staticClass: "selectLabel" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        style: _vm.IsWidth01,
                                        model: {
                                          value: _vm.queryForm.params.timeType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryForm.params,
                                              "timeType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryForm.params.timeType",
                                        },
                                      },
                                      _vm._l(_vm.timeTypeList, function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "default-time": ["00:00:00", "23:59:59"],
                                  format:
                                    _vm.$i18n.locale == "zh"
                                      ? _vm.zhDate
                                      : _vm.ptDate,
                                  placeholder: _vm.$t(
                                    "newOrder.SelectDatetime"
                                  ),
                                  "range-separator": "~",
                                  type: "datetimerange",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value: _vm.timeValue,
                                  callback: function ($$v) {
                                    _vm.timeValue = $$v
                                  },
                                  expression: "timeValue",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("newOrder.waybillStatus"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t("GlobalSetObj.all"),
                                    clearable: "",
                                    "collapse-tags": "",
                                    filterable: "",
                                    multiple: "",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.queryForm.params.waybillStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "waybillStatus",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.waybillStatus",
                                  },
                                },
                                _vm._l(_vm.waybillStatusList, function (item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    attrs: {
                                      label: item.label,
                                      value: item.code,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: _vm.$t("collectionCenter.CustomerName"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "spareNumberPoo.Only10AreDisplayed"
                                    ),
                                    "remote-method": _vm.getCustomerPage,
                                    clearable: "",
                                    "collapse-tags": "",
                                    filterable: "",
                                    multiple: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                  },
                                  on: {
                                    clear: function ($event) {
                                      return _vm.getCustomerPage("")
                                    },
                                    focus: function ($event) {
                                      return _vm.getCustomerPage("", true)
                                    },
                                  },
                                  model: {
                                    value: _vm.queryForm.params.customerIds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "customerIds",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.customerIds",
                                  },
                                },
                                _vm._l(_vm.customerList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label:
                                        item.customerAlias +
                                        "(" +
                                        item.username +
                                        ")",
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("collectionCenter.region"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "collectionCenter.tudo"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                  },
                                  on: { change: _vm.changeArea },
                                  model: {
                                    value: _vm.queryForm.params.regionId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "regionId",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.regionId",
                                  },
                                },
                                _vm._l(_vm.bigAreaList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label:
                                        item.zhName + "（" + item.puName + "）",
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("newOrder.RecipientState"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                    multiple: "",
                                  },
                                  model: {
                                    value: _vm.queryForm.params.receiveStates,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "receiveStates",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.receiveStates",
                                  },
                                },
                                _vm._l(_vm.StateList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.label,
                                      value: item.label,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("orderCenterCont.TimeoutOrNot"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.queryForm.params.isTimeout,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "isTimeout",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.isTimeout",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: 1,
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.yes"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: 0,
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.No"),
                                      value: 0,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "collectionCenter.effectiveStartHub"
                                ),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                    filterable: "",
                                    multiple: "",
                                  },
                                  model: {
                                    value:
                                      _vm.queryForm.params.transitCenterIds,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "transitCenterIds",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.transitCenterIds",
                                  },
                                },
                                _vm._l(
                                  _vm.departmentList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "waybillNumberType" } },
                            [
                              _c("template", { slot: "label" }, [
                                _c(
                                  "div",
                                  { staticClass: "selectLabel" },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        style: _vm.IsWidth,
                                        model: {
                                          value:
                                            _vm.queryForm.params
                                              .waybillNumberType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryForm.params,
                                              "waybillNumberType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryForm.params.waybillNumberType",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          key: "1",
                                          attrs: {
                                            label: _vm.$t(
                                              "newOrder.waybillNumber"
                                            ),
                                            value: 0,
                                          },
                                        }),
                                        _c("el-option", {
                                          key: "2",
                                          attrs: {
                                            label: _vm.$t(
                                              "GlobalSetObj.ScanNumber"
                                            ),
                                            value: 1,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t(
                                    "newOrder.PreciseSearch1"
                                  ),
                                  rows: 1,
                                  type: "textarea",
                                },
                                model: {
                                  value: _vm.queryForm.params.inputValue,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm.params,
                                      "inputValue",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.params.inputValue",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("uploadFile.assessmentStage"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryForm.params.expiryType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "expiryType",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.params.expiryType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("collectionCenter.tudo"),
                                      value: null,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "uploadFile.regionLeadTime"
                                      ),
                                      value: 0,
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "uploadFile.branchTimeliness"
                                      ),
                                      value: 1,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: 7 } }, [
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "27px" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-search",
                                  size: "small",
                                  type: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.searchResources(1)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("operationCenter.Procurar")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  icon: "el-icon-refresh-left",
                                  size: "small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.searchResources(2)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("operationCenter.reset")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                staticStyle: { "margin-bottom": "10px" },
                                attrs: {
                                  icon: "el-icon-upload2",
                                  size: "small",
                                  type: "primary",
                                },
                                on: { click: _vm.allExportOrder },
                              },
                              [_vm._v(_vm._s(_vm.$t("newOrder.export")) + " ")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.tabsClick },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: _vm.$t("collectionCenter.tudo"), name: "null" },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: _vm.$t("uploadFile.regionLeadTime"),
                  name: "0",
                },
              }),
              _c("el-tab-pane", {
                attrs: {
                  label: _vm.$t("uploadFile.branchTimeliness"),
                  name: "1",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                },
              }),
              _vm._l(_vm.tableHeaderList, function (item, ind) {
                return _c(
                  "el-table-column",
                  {
                    key: ind,
                    attrs: {
                      align: item.align,
                      "min-width": item.width,
                      prop: item.prop,
                      "show-overflow-tooltip": true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              item.prop === "waybillNumber"
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "#409eff",
                                        cursor: "pointer",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toOrderDetail(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.waybillNumber) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _c("div", [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row[item.prop] || "--") +
                                        " "
                                    ),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c("div", [_vm._v(_vm._s(item.label))]),
                    ]),
                  ],
                  2
                )
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getCurrentTableData,
                  "size-change": _vm.getSizeTableData,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            visible: _vm.waybillDescription,
            "custom-class": "drawerClass",
            direction: "ltr",
            size: "90%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.waybillDescription = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "calc(100vh - 67px)", overflow: "auto" } },
            [
              _c("detailPage", {
                key: _vm.detailKey,
                attrs: {
                  "query-track-param": _vm.queryTrackParam,
                  "query-type": "1",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }